import {Component} from '@angular/core';

@Component({
  selector: 'app-empty-sidebar-icon',
  standalone: true,
  imports: [],
  templateUrl: './empty-sidebar-icon.component.html',
  styleUrl: './empty-sidebar-icon.component.css',
})
export class EmptySidebarIconComponent {}
